/**
 * Maintain alpha sort order
 */
export const DEFAULT_ITEMS_PER_UNIT_VALUE = 1;
export const DESCRIPTION_COLUMN = 'description';
export const DISCOUNT_COLUMN = 'discount';
export const ID_COLUMN = 'id';
export const ITEMS_PER_UNIT_COLUMN = 'quantity';
export const LOGISTICS_CHARGE_COLUMN = 'surcharge';
export const NAME_COLUMN = 'name';
export const NEGOTIATION_PRICE_PER_UNIT_COLUMN = 'negotiationPricePerUnit';
export const NO_BID_COLUMN = 'noBid';
export const PRICE_PER_UNIT_COLUMN = 'pricePerUnit';
export const QUANTITY_OF_ITEMS_COLUMN = 'extendedQuantity';
export const QUANTITY_OF_UNITS_COLUMN = 'quantityOfUnits';
export const REQUIRED_COLUMN = 'required';
export const SUGGESTED_PRICE_PER_UNIT_COLUMN = 'suggestedPricePerUnit';
export const UNIT_OF_MEASURE_COLUMN = 'unitOfMeasure';
